import styled from '@emotion/styled';

export default styled.h2`
  color: #352c60;
  font-size: 2em;
  font-weight: 900;
`;
